(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6573],{

/***/ 6785:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/create-api",
      function () {
        return __webpack_require__(52500);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13511:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/AwsLogo.33de308b.svg","height":182,"width":304});

/***/ }),

/***/ 52500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ create_api; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/platform/layout/PlatformLayout.jsx + 14 modules
var PlatformLayout = __webpack_require__(87955);
// EXTERNAL MODULE: ./src/platform/layout/PlatformHead.jsx
var PlatformHead = __webpack_require__(75168);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/breadcrumbs/index.jsx + 2 modules
var breadcrumbs = __webpack_require__(46362);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/input_field/index.jsx
var input_field = __webpack_require__(71493);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/textarea_field/index.jsx + 2 modules
var textarea_field = __webpack_require__(58733);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/tooltip/index.jsx + 4 modules
var tooltip = __webpack_require__(88440);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/string.js
var string = __webpack_require__(46553);
// EXTERNAL MODULE: ./src/platform/assets/datasourceLogos/demyst.png
var demyst = __webpack_require__(25883);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/platform/views/UseCases/CreateDataCatalog/CategoryLogo.jsx



var CategoryLogo = function(param) {
    var category = param.category;
    switch(category){
        case "Business":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiBriefcase */.ggF, {});
            }
        case "People":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiUsers */.WY8, {});
            }
        case "Automotive":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiTruck */.C4B, {});
            }
        case "Property":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiHome */.m6D, {});
            }
        case "Digital":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiCpu */.Par, {});
            }
        case "Weather":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiSun */.kXG, {});
            }
        default:
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiGlobe */.RsK, {});
            }
    }
};
CategoryLogo.propTypes = {
    category: prop_types.PropTypes.string
};

// EXTERNAL MODULE: ./src/platform/assets/svg/flags/AUFlag.svg
var AUFlag = __webpack_require__(22788);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/CAFlag.svg
var CAFlag = __webpack_require__(29886);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/DEFlag.svg
var DEFlag = __webpack_require__(57983);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/GlobeFlag.svg
var GlobeFlag = __webpack_require__(29518);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/IDFlag.svg
var IDFlag = __webpack_require__(82183);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/INFlag.svg
var INFlag = __webpack_require__(20744);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/MXFlag.svg
var MXFlag = __webpack_require__(38805);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/NAFlag.svg
var NAFlag = __webpack_require__(13851);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/NZFlag.svg
var NZFlag = __webpack_require__(86578);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/PFlag.svg
var PFlag = __webpack_require__(98367);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/SGFlag.svg
var SGFlag = __webpack_require__(68882);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/UKFlag.svg
var UKFlag = __webpack_require__(57260);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/USFlag.svg
var USFlag = __webpack_require__(77799);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/ESFlag.svg
var ESFlag = __webpack_require__(95629);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/FRFlag.svg
var FRFlag = __webpack_require__(18250);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/VNFlag.svg
var VNFlag = __webpack_require__(37202);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/HKFlag.svg
var HKFlag = __webpack_require__(35686);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/THFlag.svg
var THFlag = __webpack_require__(68083);
;// CONCATENATED MODULE: ./src/platform/views/UseCases/CreateDataCatalog/RegionLogo.jsx




















var RegionLogo = function(param) {
    var name = param.name, className = param.className;
    switch(name){
        case "Australia":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: AUFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Canada":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: CAFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Germany":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: DEFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Global":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: GlobeFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Indonesia":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: IDFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "India":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: INFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Mexico":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: MXFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "North America":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: NAFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "New Zealand":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: NZFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Phillippines":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: PFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Singapore":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: SGFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Spain":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: ESFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "France":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: FRFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Vietnam":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: VNFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Hong Kong":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: HKFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Thailand":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: THFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "United Kingdom":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: UKFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "United States":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: USFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        default:
            {
                return null;
            }
    }
};
RegionLogo.propTypes = {
    name: prop_types.PropTypes.string
};

// EXTERNAL MODULE: ./src/platform/assets/svg/AwsLogo.svg
var AwsLogo = __webpack_require__(13511);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/framer-motion.es.js
var framer_motion_es = __webpack_require__(6805);
// EXTERNAL MODULE: ./node_modules/react-click-away-listener/dist/react-click-away-listener.es.js
var react_click_away_listener_es = __webpack_require__(55078);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
;// CONCATENATED MODULE: ./src/platform/views/UseCases/CreateDataCatalog/ConnectorCard.jsx















var ConnectorCard = function(param) {
    var data = param.data, connectorRemoved = param.connectorRemoved;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(false), menuOpen = ref5[0], setMenuOpen = ref5[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "ConnectorCard",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "ConnectorCard__header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "ConnectorCard__menu__container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "ConnectorCard__menu ".concat(menuOpen ? "open" : ""),
                                onClick: function() {
                                    return setMenuOpen(true);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiMoreHorizontal */.K9M, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                                children: menuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_click_away_listener_es/* default */.Z, {
                                    onClickAway: function() {
                                        return setMenuOpen(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, appConfig/* animatePresenceConfig */.Rr), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "ConnectorCard__menu__list",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: "".concat(linksConstants/* linksConstants.CONNECTOR_ROOT */.s.CONNECTOR_ROOT, "/").concat(data.id),
                                                    alt: "Link to ".concat(linksConstants/* linksConstants.CONNECTOR_ROOT */.s.CONNECTOR_ROOT, "/").concat(data.id),
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    className: "ConnectorCard__menu__list__item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiBookOpen */.hbr, {}),
                                                        "View in Catalog"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    onClick: function() {
                                                        return connectorRemoved(data.id);
                                                    },
                                                    className: "ConnectorCard__menu__list__item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiTrash */.We9, {}),
                                                        "Remove Connector"
                                                    ]
                                                })
                                            ]
                                        })
                                    }))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ConnectorCard__logos",
                        children: [
                            data.logo ? data.logo.indexOf("blue_dot") === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "ConnectorCard__connectorImage",
                                src: data.logo,
                                alt: "".concat((ref = data.data_source) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.replace(/_/g, " "), " logo"),
                                loading: "eager",
                                height: "40",
                                width: "40"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "ConnectorCard__connectorImage",
                                src: demyst/* default */.Z,
                                alt: "Demyst logo",
                                width: "40",
                                height: "40"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "ConnectorCard__connectorImage",
                                src: demyst/* default */.Z,
                                alt: "Demyst logo",
                                width: "40",
                                height: "40"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ConnectorCard__source",
                                children: data.data_source ? (0,string/* toNaturalSentence */.GA)(data.data_source.name) : "Undefined"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "ConnectorCard__name",
                children: data.alias ? data.alias : (0,string/* toNaturalSentence */.GA)(data.name)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "ConnectorCard__description",
                children: data.description || /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                    children: "No description provided"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "DataCatalogItem__tags",
                children: [
                    (ref2 = data.data_regions) === null || ref2 === void 0 ? void 0 : ref2.map(function(region) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "DataCatalogItem__tag",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "DataCatalogItem__logoContainer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionLogo, {
                                        name: region.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: region.name
                                })
                            ]
                        }, region.name);
                    }),
                    data.data_category && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "DataCatalogItem__tag",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLogo, {
                                category: (ref3 = data.data_category) === null || ref3 === void 0 ? void 0 : ref3.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (ref4 = data.data_category) === null || ref4 === void 0 ? void 0 : ref4.name
                            })
                        ]
                    }),
                    data.adx_flag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "DataCatalogItem__awsTag",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: AwsLogo/* default */.Z,
                            alt: "AWS Amazon Data Exchange Enabled"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@demystdata/ui/button/index.jsx
var ui_button = __webpack_require__(58278);
// EXTERNAL MODULE: ./src/platform/views/UseCases/CreateDataCatalog/CreateAddConnectorModal.jsx
var CreateAddConnectorModal = __webpack_require__(20018);
;// CONCATENATED MODULE: ./src/platform/views/UseCases/CreateDataCatalog/AddConnectorCard.jsx





var AddConnectorCard = function(param) {
    var connectors = param.connectors, setConnector = param.setConnector, isFirst = param.isFirst;
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "AddConnectorCard",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "AddConnectorCard__name",
                children: isFirst ? "You don't have any connectors added to your Data API yet." : "You can add as many connectors as you'd like"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "AddConnectorCard__description",
                children: isFirst ? "To get started, click the button below and add an external data connector. You will be able to access any connector you add when utilizing your Data API." : "Connectors in your Data API will share their matching input properties."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                className: "AddConnectorCard__button",
                leftIconSrc: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiPlus */.OvN, {}),
                onClick: function() {
                    return setModalOpen(true);
                },
                children: isFirst ? "Add Connector" : "Add Another Connector"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateAddConnectorModal/* CreateAddConnectorModal */._, {
                connectors: connectors,
                setConnector: setConnector,
                modalOpen: modalOpen,
                setModalOpen: setModalOpen
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/api/productsCatalogApi.js
var productsCatalogApi = __webpack_require__(43420);
// EXTERNAL MODULE: ./src/platform/views/DataCatalog/components/dataPages/CloneAPIModal.jsx
var CloneAPIModal = __webpack_require__(12227);
;// CONCATENATED MODULE: ./src/platform/views/UseCases/CreateDataAPI.jsx



















var CreateDataAPI = function() {
    var ref = (0,react.useState)(""), title = ref[0], setTitle = ref[1];
    var ref1 = (0,react.useState)(false), titleEdited = ref1[0], setTitleEdited = ref1[1];
    var ref2 = (0,react.useState)(""), description = ref2[0], setDescription = ref2[1];
    var ref3 = (0,react.useState)(false), descriptionEdited = ref3[0], setDescriptionEdited = ref3[1];
    var ref4 = (0,react.useState)([]), connectors = ref4[0], setConnectors = ref4[1];
    var ref5 = (0,react.useState)(false), cloneAPIModalOpen = ref5[0], setCloneAPIModalOpen = ref5[1];
    var breadCrumbItems = [
        {
            href: linksConstants/* linksConstants.ALL_USE_CASES */.s.ALL_USE_CASES,
            label: "Data APIs"
        },
        {
            href: null,
            label: "New Data API"
        }, 
    ];
    var handleKeyDown = function(e) {
        if (e.code === "Enter") {
            if (titleEdited === true) setTitleEdited(false);
            if (descriptionEdited === true) setDescriptionEdited(false);
        }
    };
    var connectorSelected = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(connector) {
            var connectorsCopy, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        connectorsCopy = (0,_to_consumable_array/* default */.Z)(connectors);
                        _ctx.next = 3;
                        return productsCatalogApi/* productsCatalogApi.getProduct */.r.getProduct(connector.id);
                    case 3:
                        data = _ctx.sent.data;
                        connectorsCopy.push(data);
                        setConnectors(connectorsCopy);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function connectorSelected(connector) {
            return _ref.apply(this, arguments);
        };
    }();
    var connectorRemoved = function(id) {
        var connectorsCopy = (0,_to_consumable_array/* default */.Z)(connectors);
        var filteredItem = connectorsCopy.filter(function(item) {
            return item.id !== id;
        });
        setConnectors(filteredItem);
    };
    var openCloneAPIModal = function() {
        setCloneAPIModalOpen(true);
    };
    var closeCloneAPIModal = function() {
        setCloneAPIModalOpen(false);
    };
    var saveDataAPI = function() {
        openCloneAPIModal();
    };
    (0,react.useEffect)(function() {
        if (titleEdited === true) {
            var ref;
            (ref = document.getElementById("title-input")) === null || ref === void 0 ? void 0 : ref.focus();
        }
        if (descriptionEdited === true) {
            var ref1;
            (ref1 = document.getElementById("description-input")) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    }, [
        titleEdited,
        descriptionEdited
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("keydown", function(e) {
            return handleKeyDown(e);
        });
        return function() {
            document.removeEventListener("keydown", function(e) {
                return handleKeyDown(e);
            });
        };
    }, [
        titleEdited,
        descriptionEdited
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "CreateDataAPI",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformHead/* PlatformHead */.$, {
                title: "Create Data API"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloneAPIModal/* CloneAPIModal */.s, {
                open: cloneAPIModalOpen,
                closeModal: closeCloneAPIModal,
                variant: "FROM_CREATE_DATA_API",
                id: 69,
                name: title,
                description: description,
                connectors: connectors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "CreateDataAPI__contentWrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "CreateDataAPI__breadcrumbs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs/* default */.Z, {
                            items: breadCrumbItems,
                            variant: "tertiary"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "CreateDataAPI__nameSection",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "CreateDataAPI__nameSection__title",
                                children: [
                                    !titleEdited && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            title === "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "CreateDataAPI__nameSection__title__text",
                                                children: "Untitled Data API"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                                ariaLabel: "ARIA label",
                                                label: title,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "CreateDataAPI__nameSection__title__text",
                                                    children: title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                                                variant: "tertiary",
                                                onClick: function() {
                                                    return setTitleEdited(true);
                                                },
                                                className: "CreateDataAPI__nameSection__title__button",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiEdit2 */.IYd, {})
                                            })
                                        ]
                                    }),
                                    titleEdited && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_click_away_listener_es/* default */.Z, {
                                            onClickAway: function() {
                                                return setTitleEdited(false);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_field/* default */.Z, {
                                                    label: "",
                                                    id: "title-input",
                                                    autoComplete: "off",
                                                    name: "input",
                                                    onChange: function(e) {
                                                        return setTitle(e);
                                                    },
                                                    placeholder: "Start typing Data API name...",
                                                    hideOptional: true,
                                                    required: false,
                                                    value: title,
                                                    className: "CreateDataAPI__nameSection__title__input",
                                                    type: "text"
                                                })
                                            })
                                        })
                                    }),
                                    connectors.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                        ariaLabel: "You need connectors in your Data API to continue.",
                                        color: "blue",
                                        label: "You need connectors in your Data API to continue.",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                                            variant: "primary",
                                            leftIconSrc: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiSave */.mW3, {}),
                                            disabled: true,
                                            onClick: saveDataAPI,
                                            className: "CreateDataAPI__nameSection__title__saveButton",
                                            children: "Save & Create"
                                        })
                                    }),
                                    connectors.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                                        variant: "primary",
                                        leftIconSrc: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiSave */.mW3, {}),
                                        onClick: saveDataAPI,
                                        className: "CreateDataAPI__nameSection__title__saveButton",
                                        children: "Save & Create"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "CreateDataAPI__nameSection__description",
                                children: [
                                    !descriptionEdited && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "CreateDataAPI__nameSection__description__button",
                                        onClick: function() {
                                            return setDescriptionEdited(true);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "CreateDataAPI__nameSection__description__text",
                                            children: description === "" ? "Click here to enter description..." : description
                                        })
                                    }),
                                    descriptionEdited && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_click_away_listener_es/* default */.Z, {
                                            onClickAway: function() {
                                                return setDescriptionEdited(false);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_field/* default */.Z, {
                                                    label: "",
                                                    id: "description-input",
                                                    name: "textarea",
                                                    onChange: function(e) {
                                                        return setDescription(e);
                                                    },
                                                    placeholder: "Enter description...",
                                                    hideOptional: true,
                                                    required: false,
                                                    value: description,
                                                    className: "CreateDataAPI__nameSection__description__textarea"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            connectors.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                ariaLabel: "You need connectors in your Data API to continue.",
                                color: "blue",
                                label: "You need connectors in your Data API to continue.",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                                    variant: "primary",
                                    leftIconSrc: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiSave */.mW3, {}),
                                    disabled: true,
                                    onClick: saveDataAPI,
                                    className: "CreateDataAPI__nameSection__saveButton",
                                    children: "Save & Create"
                                })
                            }),
                            connectors.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                                variant: "primary",
                                leftIconSrc: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiSave */.mW3, {}),
                                onClick: saveDataAPI,
                                className: "CreateDataAPI__nameSection__saveButton",
                                children: "Save & Create"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "CreateDataAPI__connectorSection",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "CreateDataAPI__connectorSection__text",
                                children: "Select connectors"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "CreateDataAPI__connectorSection__table",
                                children: [
                                    connectors.map(function(connector) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectorCard, {
                                            data: connector,
                                            connectorRemoved: connectorRemoved
                                        }, connector.id);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddConnectorCard, {
                                        connectors: connectors,
                                        setConnector: connectorSelected,
                                        isFirst: connectors.length === 0
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/app/create-api.jsx





var CreateApiPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformHead/* PlatformHead */.$, {
                currentPath: linksConstants/* linksConstants.CREATE_DATA_API */.s.CREATE_DATA_API,
                title: "Create Data API"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformLayout/* default */.Z, {
                isAuthRequired: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateDataAPI, {})
            })
        ]
    });
};
/* harmony default export */ var create_api = (CreateApiPage);


/***/ }),

/***/ 71493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InputField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _reach_auto_id__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(765);
/* harmony import */ var _field__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33076);
/* harmony import */ var _input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72622);







/**
 * Renders an input field. Supports various types.
 */ function InputField(_param) {
    var className = _param.className, hideOptional = _param.hideOptional, hint = _param.hint, id = _param.id, label = _param.label, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "hideOptional",
        "hint",
        "id",
        "label"
    ]);
    var idWithDefault = (0,_reach_auto_id__WEBPACK_IMPORTED_MODULE_4__/* .useId */ .M)(id);
    var disabled = otherProps.disabled, required = otherProps.required, type = otherProps.type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_field__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: className,
        disabled: disabled,
        hideOptional: hideOptional,
        hint: hint,
        id: idWithDefault,
        label: label,
        required: required,
        type: type,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            id: idWithDefault
        }, otherProps))
    });
};
InputField.propTypes = {
    /**
   * ARIA label.
   */ ariaLabel: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    /** Autocomplete attribute. Refer to https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete for more details. */ autoComplete: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOf([
        "off",
        "name",
        "honorific-prefix",
        "given-name",
        "additional-name",
        "family-name",
        "honorific-suffix",
        "nickname",
        "email",
        "username",
        "new-password",
        "current-password",
        "one-time-code",
        "organization-title",
        "organization",
        "street-address",
        "address-line1",
        "address-line2",
        "address-line3",
        "address-level4",
        "address-level3",
        "address-level2",
        "address-level1",
        "country",
        "country-name",
        "postal-code",
        "cc-name",
        "cc-given-name",
        "cc-additional-name",
        "cc-number",
        "cc-exp",
        "cc-exp-month",
        "cc-exp-year",
        "cc-csc",
        "cc-type",
        "transation-currency",
        "transaction-amount",
        "language",
        "bday",
        "bday-day",
        "bday-month",
        "bday-year",
        "sex",
        "tel",
        "tel-country-code",
        "tel-national",
        "tel-area-code",
        "tel-local",
        "tel-extension",
        "impp",
        "url",
        "photo", 
    ]),
    /**
   * Whether to automatically focus input on mount.
   */ autoFocus: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    /**
   * Field class name.
   */ className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    /**
   * Default value. Use for uncontrolled inputs.
   */ defaultValue: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number)
    ]),
    /**
   * Whether to disable the input.
   */ disabled: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    /**
   * Whether to hide "Optional" label despite field not being required.
   */ hideOptional: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    /**
   * Input hint. Displayed below the input.
   */ hint: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
    /**
   * Input ID. If not provided, ID will be automatically generated.
   */ id: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    /**
   * Input label. Displayed above the input.
   */ label: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
    /**
   * Left icon height in pixels (recommended if icon URL is used).
   */ leftIconHeight: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    /**
   * Left icon, left icon source or left icon URL.
   */ leftIconSrc: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().element),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string), 
    ]),
    /**
   * Left icon width in pixels (recommended if icon URL is used).
   */ leftIconWidth: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    /**
   * Input name.
   */ name: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
    /**
   * Function called on change. Will be called with two attributes: `value` and `event`.
   */ onChange: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    /**
   * Input placeholder.
   */ placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    /**
   * Whether the input should be required.
   */ required: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    /**
   * Right icon height in pixels (recommended if icon URL is used).
   */ rightIconHeight: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    /**
   * Right icon, right icon source or right icon URL.
   */ rightIconSrc: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().element),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string), 
    ]),
    /**
   * Right icon width in pixels (recommended if icon URL is used).
   */ rightIconWidth: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    /**
   * Input size.
   */ size: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOf([
        "regular",
        "small"
    ]),
    /**
   * Input type.
   */ type: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOf([
        "color",
        "date",
        "datetime-local",
        "email",
        "file",
        "number",
        "password",
        "search",
        "tel",
        "text",
        "time",
        "url", 
    ]),
    /**
   * Value. Use for controlled inputs along with `onChange`.
   */ value: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_6___default().instanceOf(Date),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number)
    ])
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,2777,314,8278,9440,5675,6723,8269,8440,5,7955,1722,18,9774,2888,179], function() { return __webpack_exec__(6785); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);